import React from 'react';
import { Shield } from 'lucide-react';
import LegalPageLayout, { LegalSection } from './LegalPageLayout';

const PrivacyPolicyPage = ({ totalItems, totalFavorites, setCurrentPage }) => {
  return (
    <LegalPageLayout
      title="سياسة الخصوصية"
      icon={<Shield className="h-8 w-8" />}
      lastUpdated="17 يوليو 2026"
      totalItems={totalItems}
      totalFavorites={totalFavorites}
      setCurrentPage={setCurrentPage}
    >
      <LegalSection title="مقدمة">
        <p>
          تحرص صيدلية الريان على حماية خصوصية عملائها. توضح هذه السياسة نوع البيانات التي نجمعها،
          وكيفية استخدامها، والإجراءات المتبعة لحمايتها عند استخدامك لموقعنا الإلكتروني أو تطبيقنا.
        </p>
      </LegalSection>

      <LegalSection title="البيانات التي نجمعها">
        <ul className="list-inside list-disc space-y-2">
          <li>معلومات التعريف الشخصية: الاسم، رقم الهاتف، البريد الإلكتروني، والعنوان.</li>
          <li>بيانات الطلبات: المنتجات المشتراة، طريقة الدفع، وتاريخ الشراء.</li>
          <li>بيانات الاستخدام: الصفحات التي تزورها، ومدة تصفحك للموقع.</li>
        </ul>
      </LegalSection>

      <LegalSection title="كيفية استخدام بياناتك">
        <p>نستخدم بياناتك للأغراض التالية:</p>
        <ul className="list-inside list-disc space-y-2">
          <li>تجهيز طلباتك وتوصيلها بدقة.</li>
          <li>التواصل معك بخصوص حالة الطلب أو الاستشارات الصيدلانية.</li>
          <li>تحسين تجربتك على الموقع وتخصيص العروض المناسبة لك.</li>
        </ul>
      </LegalSection>

      <LegalSection title="حماية البيانات">
        <p>
          نطبّق إجراءات أمنية تقنية وإدارية لحماية بياناتك من الوصول أو الاستخدام غير المصرح به،
          ولا نشارك بياناتك الطبية أو الشخصية مع أي طرف ثالث دون موافقتك، إلا في الحالات التي
          يفرضها القانون.
        </p>
      </LegalSection>

      <LegalSection title="حقوقك">
        <p>
          يحق لك في أي وقت طلب الاطلاع على بياناتك، تعديلها، أو حذفها من خلال التواصل مع فريق
          خدمة العملاء عبر صفحة "اتصل بنا".
        </p>
      </LegalSection>
    </LegalPageLayout>
  );
};

export default PrivacyPolicyPage;
